"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var overview_aggregate_config_model_1 = require("../../../../common/model/overview-aggregate-config.model");
var custom_aggregate_functions_provider_service_1 = require("../../../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var custom_aggregate_filtering_provider_service_1 = require("../../../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-filtering-provider.service");
var overview_card_type_1 = require("../../../../common/model/overview-card-type");
var summary_page_configs_helper_service_1 = require("../../../../common/service/summary-page-configs-helper.service");
var OverviewAggregateDialogComponent = /** @class */ (function () {
    function OverviewAggregateDialogComponent(customAggregateFunctionsProvider, customAggregateFilteringProviderService, dialogRef, summaryPageConfigsHelperService, dialog, data) {
        this.customAggregateFunctionsProvider = customAggregateFunctionsProvider;
        this.customAggregateFilteringProviderService = customAggregateFilteringProviderService;
        this.dialogRef = dialogRef;
        this.summaryPageConfigsHelperService = summaryPageConfigsHelperService;
        this.dialog = dialog;
        this.data = data;
        this.isGroupCard = false;
        this.isValidSourceField = true;
        this.isValidAggregateField = true;
        this.isValidAggregateFunction = true;
        this.aggregateConfig = new overview_aggregate_config_model_1.OverviewAggregateConfigModel();
        this.customAggregateFunctions$ = Observable_1.Observable.of([]);
        this.groupingFields$ = Observable_1.Observable.of([]);
        this.category = data.category;
        this.rootCategory = data.rootCategory;
        this.aggregateConfig = data.aggregateConfig || this.aggregateConfig;
        this.isGroupCard = data.cardType === overview_card_type_1.OverviewCardType.GROUP_CARD;
        this.isPortfolioField = data.isPortfolioField;
    }
    OverviewAggregateDialogComponent.getDialogConfig = function () {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '600px';
        return dialogConfig;
    };
    OverviewAggregateDialogComponent.prototype.ngOnInit = function () {
        this.setCustomAggregateFunctions();
        /**
         * If the card is {@link OverviewCardType.GROUP_CARD} => grouping main entities
         * If not Group Card => grouping sub-entities
         */
        if (this.isGroupCard) {
            this.setGroupingFields(this.category);
            this.setCustomAggregateFilteringArray(this.category);
        }
        else {
            this.setSourceFields();
        }
    };
    OverviewAggregateDialogComponent.prototype.setGroupingFields = function (category) {
        var _this = this;
        this.aggregateConfig.aggregationCategory = category;
        this.groupingFields$ = this.summaryPageConfigsHelperService
            .getFieldsByEntity(category, [idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER, idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE]).pipe(operators_1.tap(function (metaFields) {
            _this.groupingFields = metaFields;
            if (_this.aggregateConfig.groupingField) {
                var currentGroupingField = _this.groupingFields
                    .find(function (field) { return field.getSystemName() === _this.aggregateConfig.groupingField; });
                _this.aggregateConfig.groupingField = currentGroupingField && currentGroupingField.getSystemName();
            }
        }));
    };
    OverviewAggregateDialogComponent.prototype.setCustomAggregateFilteringArray = function (category) {
        this.customAggregateFilteringArray$ = this.customAggregateFilteringProviderService.getCustomAggregateFilters(category);
    };
    OverviewAggregateDialogComponent.prototype.setSourceFields = function () {
        var _this = this;
        this.sourceFields$ = this.summaryPageConfigsHelperService
            .getFieldsByEntity(this.category, [idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT, idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY]).pipe(operators_1.tap(function (metaFields) {
            _this.sourceFields = metaFields;
            if (_this.aggregateConfig.sourceField) {
                _this.changeSourceField(_this.aggregateConfig.sourceField);
            }
        }));
    };
    OverviewAggregateDialogComponent.prototype.setCustomAggregateFunctions = function () {
        var _this = this;
        if (this.aggregateConfig) {
            this.customAggregateFunctions$ = this.customAggregateFunctionsProvider.getCustomAggregateFunctions(this.category, this.rootCategory).pipe(operators_1.tap(function (functions) {
                _this.customAggregateFunctions = functions;
                if (_this.aggregateConfig.aggregateFunction) {
                    _this.changeAggregateFunction(_this.aggregateConfig.aggregateFunction);
                }
            }));
        }
        else {
            this.customAggregateFunctions$ = Observable_1.Observable.of(null);
        }
    };
    OverviewAggregateDialogComponent.prototype.setCustomAggregateFunctionArguments = function (aggregateFunction) {
        var _this = this;
        if (aggregateFunction && aggregateFunction.appliedToFieldTypes && aggregateFunction.appliedToFieldTypes.length) {
            this.aggregateFields$ = this.summaryPageConfigsHelperService
                .getFieldsByEntity(this.aggregateConfig.aggregationCategory, aggregateFunction.appliedToFieldTypes).pipe(operators_1.tap(function (metaFields) {
                _this.aggregateFields = metaFields;
            }));
        }
        else {
            this.aggregateFields$ = Observable_1.Observable.of(null);
        }
    };
    OverviewAggregateDialogComponent.prototype.changeSourceField = function (field) {
        var _this = this;
        this.aggregateConfig.sourceField = field;
        if (field) {
            if (field !== this.aggregateConfig.sourceField) {
                this.aggregateConfig = new overview_aggregate_config_model_1.OverviewAggregateConfigModel();
                this.aggregateConfig.sourceField = field;
            }
            var sourceMetaField = this.sourceFields.find(function (metaField) { return metaField.getSystemName() === field; });
            sourceMetaField && this.setCustomAggregateFilteringArray(sourceMetaField.getCompoundCategorySystemName());
            if (!this.isGroupCard) {
                var sourceField = this.sourceFields.find(function (metaField) { return metaField.getSystemName() === _this.aggregateConfig.sourceField; });
                this.setGroupingFields(sourceField.getCompoundCategorySystemName());
            }
            else {
                this.setGroupingFields(this.category);
            }
            if (this.customAggregateFunctions) {
                this.setCustomAggregateFunctionArguments(this.customAggregateFunctions.find(function (customAggr) {
                    return _this.aggregateConfig.aggregateFunction === customAggr.key;
                }));
            }
        }
        else {
            this.aggregateConfig = new overview_aggregate_config_model_1.OverviewAggregateConfigModel();
        }
    };
    OverviewAggregateDialogComponent.prototype.changeGroupingField = function (field) {
        this.aggregateConfig.groupingField = field;
        if (field) {
            var groupingField = this.groupingFields.find(function (metaField) { return metaField.getSystemName() === field; });
            this.aggregateConfig.groupingFieldType = groupingField.getType();
            this.aggregateConfig.groupingFieldCompoundCategory = groupingField.getCompoundCategorySystemName();
        }
        else {
            this.aggregateConfig.groupingFieldType = null;
            this.aggregateConfig.groupingFieldCompoundCategory = null;
        }
    };
    OverviewAggregateDialogComponent.prototype.changeAggregateFunction = function (functionKey) {
        var customAggregationFunction = null;
        if (functionKey !== this.aggregateConfig.aggregateFunction || !this.aggregateFields$) {
            this.aggregateConfig.aggregateFunction = functionKey;
            if (functionKey) {
                customAggregationFunction = this.customAggregateFunctions.find(function (func) { return func.key === functionKey; });
            }
            else {
                this.aggregateConfig.aggregateField = null;
            }
        }
        this.setCustomAggregateFunctionArguments(customAggregationFunction);
    };
    OverviewAggregateDialogComponent.prototype.changeAggregateField = function (field) {
        this.aggregateConfig.aggregateField = field;
        if (field) {
            var aggregateField = this.aggregateFields.find(function (metaField) { return metaField.getSystemName() === field; });
            this.aggregateConfig.aggregateFieldType = aggregateField.getType();
        }
        else {
            this.aggregateConfig.aggregateFieldType = null;
        }
    };
    OverviewAggregateDialogComponent.prototype.validateFields = function () {
        var _this = this;
        var customAggregationFunction = this.customAggregateFunctions.find(function (func) { return func.key === _this.aggregateConfig.aggregateFunction; });
        this.isValidAggregateField = customAggregationFunction && (!customAggregationFunction.appliedToFieldTypes ||
            !customAggregationFunction.appliedToFieldTypes.length || !!this.aggregateConfig.aggregateField);
        this.isValidAggregateFunction = !!this.aggregateConfig.aggregateFunction;
        this.isValidSourceField = this.isGroupCard || !!this.aggregateConfig.sourceField;
        return this.isValidAggregateField && this.isValidAggregateFunction && this.isValidSourceField;
    };
    OverviewAggregateDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    OverviewAggregateDialogComponent.prototype.save = function () {
        if (this.validateFields()) {
            this.dialogRef.close(this.aggregateConfig);
        }
    };
    OverviewAggregateDialogComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-overview-aggregate-dialog',
            styles: [require('./overview-aggregate-dialog.component.css')],
            template: require('./overview-aggregate-dialog.component.html'),
        }),
        __param(0, core_1.Optional()),
        __param(1, core_1.Optional()),
        __param(5, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService,
            custom_aggregate_filtering_provider_service_1.CustomAggregateFilteringProviderService,
            material_1.MatDialogRef,
            summary_page_configs_helper_service_1.SummaryPageConfigsHelperService,
            material_1.MatDialog, Object])
    ], OverviewAggregateDialogComponent);
    return OverviewAggregateDialogComponent;
}());
exports.OverviewAggregateDialogComponent = OverviewAggregateDialogComponent;
//# sourceMappingURL=overview-aggregate-dialog.component.js.map